import { Component } from '@angular/core';
import { ViewController, NavParams, NavController } from 'ionic-angular';
import { List } from 'linqts';

import { PageDefault } from '../PageDefault';
import { AlertService } from '../../providers/alert.service';
import { BettingService } from '../../services/betting.service';
import { BettingOrderHelper } from './bettingorder.helper';
import { StorageService } from '../../providers/storage.service';
import { SysconfigModel, UserModel } from '../../models/user.model';
import { PlayDetailModel } from '../../models/betting.model';
import { CurrIssue } from '../../models/bettingorder.dto';
import { BettingOrderPage } from './bettingorder';
import { LoaddingService } from '../../providers/loadding.service';

/*
  追号页面
  TQQ 2017-01-11
*/
@Component({
    selector: 'page-chasebetting',
    templateUrl: 'bettingchase.html',
    providers: [BettingService, BettingOrderHelper]
})
export class BettingChase {

    para: any = {
        currIssue: new CurrIssue(),
        order: null,
        lotteryCode: "",
        lotteryName: "",
        playDetail: new PlayDetailModel(),
        adjustReward: 0,
        rewardUp: 0,
        rewardDown: 0,
        baseReward: 0,
        formatRemain: "00:00:00"
    };

    setIntervalid : any;
    sysconfig: SysconfigModel = new SysconfigModel();
    currUser: UserModel = new UserModel;
    bettingMoneyInit: number = 0;

    constructor(
        private viewCtrl: ViewController,
        private navpar: NavParams,
        private alert: AlertService,
        private bettingService: BettingService,
        private bettinghelper: BettingOrderHelper,
        private storage: StorageService,
        private navCtrl: NavController,
        private loadding: LoaddingService
    ) {
        this.para = navpar.data;
        this.setIntervalid = setInterval(s => {
            this.para.currIssue.RemainTime -= 1000;
            this.issueTimerCallback(this.para.currIssue.RemainTime);
        }, 1000);
        this.sysconfig = this.storage.read<SysconfigModel>("sysconfig");
        this.currUser = this.storage.read<UserModel>("User");
        if (this.para.playType == 1) {
            this.bettingMoneyInit = this.para.bettingMoneyCount.BettingMoney;
            this.chaseParams.type = "same";
            this.dollarGenerate();
        } else {
            if (this.para.order.lotteryPlayDetailCode != this.para.playDetail.LotteryPlayDetailCode) {
                this.bettingService.getPlayDetail(this.para.order.lotteryPlayDetailCode).then(s => {
                    this.para.playDetail = s.PlayDetail;
                    this.para.playDetail.Algorithm = s.Algorithm;
                    this.generate();
                });
            } else {
                this.generate();
            }
        }
    }
    chasetab: string = "profit";


    chaseParams = {
        type: "profit", count: 10, startMultiple: 1, maxMultiple: 100,
        minProfit: 30, expTimes: 1, operation: 'x', expMultiple: 2, isStop: true,
        issues: [], totalCount: 0, totalMoney: 0
    };

    ionViewDidLeave() {
        clearInterval(this.setIntervalid);
    }

    getGenerate() {
        if (this.para.playType == 1) {
            this.dollarGenerate();
        } else {
            this.generate();
        }
    }
    //生成追号单
    //TQQ 2017-01-11
    generate() {
        this.chaseParams.totalCount = 0;
        this.chaseParams.totalMoney = 0;
        if (this.para.lotteryCode == "10011" && this.chaseParams.count > 880) {
            this.chaseParams.count = 880;
        }
        var issues = this.bettinghelper.getNextIssueNoList(this.para.currIssue.Issue, this.para.currIssue.CurrentIssueNo, this.chaseParams.count);
        this.chaseParams.issues = [];
        for (var j in issues) {
            var i = parseInt(j);
            var b = true;
            var chasemodel = {
                IssueNo: issues[i],
                Multiple: i > 0 ? this.chaseParams.issues[i - 1].Multiple : this.chaseParams.startMultiple,
                BettingMoney: 0,
                BettingSumMoney: 0,
                Reward: 0,
                Profit: 0,
                Profitability: "",
                checked: true
            };
            chasemodel.BettingMoney = this.sysconfig.PerBettingPrice * this.para.order.yuanjiaofen * this.InvestSumNum() * chasemodel.Multiple;
            chasemodel.BettingSumMoney = this.chaseParams.issues.length == 0 ? chasemodel.BettingMoney : this.chaseParams.issues[i - 1].BettingSumMoney + chasemodel.BettingMoney;
            chasemodel.Reward = this.getChaseReward() * chasemodel.Multiple;
            chasemodel.Profit = chasemodel.BettingSumMoney;
            if (this.para.playDetail.IsAttached) {
                chasemodel.Profitability = '-';
            } else {
                chasemodel.Profitability = chasemodel.BettingSumMoney == 0 ? "0" : ((chasemodel.Reward - chasemodel.BettingSumMoney) * 100 / chasemodel.BettingSumMoney).toFixed(2);
            }
            if (this.chaseParams.type == "profit") {
                if (this.para.playDetail.IsAttached) {
                    this.alert.showAlert('多组奖金不支持利润率追号');
                    return false;
                }
                while (parseFloat(chasemodel.Profitability) < this.chaseParams.minProfit) {
                    chasemodel.Multiple++;
                    chasemodel.BettingMoney = this.sysconfig.PerBettingPrice * this.para.order.yuanjiaofen * this.InvestSumNum() * chasemodel.Multiple;
                    chasemodel.Reward = this.getChaseReward() * chasemodel.Multiple;

                    chasemodel.BettingSumMoney = this.chaseParams.issues.length == 0 ? chasemodel.BettingMoney : this.chaseParams.issues[i - 1].BettingSumMoney + chasemodel.BettingMoney;
                    chasemodel.Profit = chasemodel.Reward - chasemodel.BettingSumMoney;
                    chasemodel.Profitability = chasemodel.BettingSumMoney == 0 ? "0" : ((chasemodel.Reward - chasemodel.BettingSumMoney) * 100 / (chasemodel.BettingSumMoney)).toFixed(2);

                    if (chasemodel.Multiple > this.chaseParams.maxMultiple) {
                        return false;
                    }
                }
            } else if (this.chaseParams.type == "double") {
                if (i > 0 && i % this.chaseParams.expTimes == 0) {
                    if (this.chaseParams.operation == "+") {
                        chasemodel.Multiple = this.chaseParams.issues[i - 1].Multiple + this.chaseParams.expMultiple;
                    } else if (this.chaseParams.operation == "x") {
                        chasemodel.Multiple = this.chaseParams.issues[i - 1].Multiple * this.chaseParams.expMultiple;
                    }
                }
            }
            chasemodel.BettingMoney = this.sysconfig.PerBettingPrice * this.para.order.yuanjiaofen * this.InvestSumNum() * chasemodel.Multiple;
            chasemodel.BettingSumMoney = this.chaseParams.issues.length == 0 ? chasemodel.BettingMoney : this.chaseParams.issues[i - 1].BettingSumMoney + chasemodel.BettingMoney;
            if (b) {
                this.chaseParams.issues.push(chasemodel);
                this.chaseParams.totalCount++;
            }
            this.chaseParams.totalMoney = this.chaseParams.issues[this.chaseParams.issues.length - 1].BettingSumMoney;

        }

    }

    InvestSumNum() {
        return this.para.order.bettingCount;
    }

    getChaseReward() {
        var setAdjust;
        var adjustRewardMode;
        if (this.para.playDetail.Algorithm.AlgorithmTypeCode == ("0105") || this.para.playDetail.Algorithm.AlgorithmTypeCode == ("0307") || this.para.playDetail.Algorithm.AlgorithmTypeCode == ("0108")) {
            if (this.sysconfig.CanAdjust) {
                this.selectAdjust();
                setAdjust = this.para.adjustReward;
                adjustRewardMode = this.para.baseReward + this.sysconfig.PerGraduation * parseFloat(setAdjust);
                return ((this.para.playDetail.CardinalMoney * adjustRewardMode / 1000 + this.para.playDetail.Modulus) * (this.sysconfig.PerBettingPrice / 4) * this.para.order.yuanjiaofen + (this.para.playDetail.CardinalMoney1 * adjustRewardMode / 1000 + this.para.playDetail.Modulus1) * (this.sysconfig.PerBettingPrice / 4) * this.para.order.yuanjiaofen) / 2;
            } else {
                return (this.para.playDetail.CardinalMoney * (this.sysconfig.PerBettingPrice / 4) * this.para.order.yuanjiaofen + this.para.playDetail.CardinalMoney1 * (this.sysconfig.PerBettingPrice / 4) * this.para.order.yuanjiaofen) / 2;
            }
        }

        if (this.sysconfig.CanAdjust) {
            this.selectAdjust();
            setAdjust = this.para.adjustReward;
            adjustRewardMode = this.para.baseReward + this.sysconfig.PerGraduation * parseFloat(setAdjust);
            return (this.para.playDetail.CardinalMoney * (adjustRewardMode / 1000) + this.para.playDetail.Modulus) * (this.sysconfig.PerBettingPrice / 4) * this.para.order.yuanjiaofen;
        } else {
            return this.para.playDetail.CardinalMoney * (this.sysconfig.PerBettingPrice / 4) * this.para.order.yuanjiaofen;
        }
    }


    selectAdjust() {
        var setAdjust = this.para.adjustReward;
        var curretBonus = this.currUser.Bonus - (setAdjust * this.sysconfig.BonusGruduation);
        curretBonus = curretBonus < 0 ? 0 : curretBonus;
        if (this.sysconfig.AdjustMaxBonus < curretBonus
            || this.sysconfig.AdjustMinBonus > curretBonus) {
            setAdjust = 0;
            this.para.adjustReward = setAdjust;
        }

        var curretRewiteMode = this.para.baseReward
            + this.sysconfig.PerGraduation * setAdjust;

        var jiaoAdjust = (this.sysconfig.JiaoMaxMode
            - this.para.baseReward) / this.sysconfig.PerGraduation;

        var fenAdjust = (this.sysconfig.FenMaxMode
            - this.para.baseReward) / this.sysconfig.PerGraduation;


        if (this.para.order.yuanjiaofen == 0.1) {
            if (curretRewiteMode > this.sysconfig.JiaoMaxMode) {
                setAdjust = jiaoAdjust;
                this.para.adjustReward = setAdjust;
            }
        } else if (this.para.order.yuanjiaofen == 0.01) {
            if (curretRewiteMode > this.sysconfig.FenMaxMode) {
                setAdjust = fenAdjust;
                this.para.adjustReward = setAdjust;
            }
        }

        if (curretRewiteMode > this.para.rewardUp) {
            setAdjust = 0;
            this.para.adjustReward = setAdjust;
        } else if (curretRewiteMode < this.para.rewardDown) {
            setAdjust = 0;
            this.para.adjustReward = setAdjust;
        }
    };

    betting = false;
    //确认投注
    //TQQ 2017-01-11
    submitBettingOrder() {
        var issueLen = this.chaseParams.issues.length;//$filter('filter')($scope.chaseParams.issues, { 'checked': true }).length;
        if (issueLen <= 0) {
            this.alert.showAlert('您没有勾选任何追号计划!');
            return;
        }
        if (this.para.playType == 1) {
            this.dollarSubmit();
            return;
        }
        if (this.betting) {
            return;
        }
        this.betting = true;

        this.subBettingInfo(this.betting);

    }


    subBettingInfo(isBettingChase) {
        var errors = [];
        let ajaxList = [];
        let para = {
            CanBetting: false,
        };
        if (this.currUser.Bonus > this.sysconfig.MaxUserBonusCanBetting) {
            para.CanBetting = false;
            throw new Error("用户返点大于可投注的最大返点");
        }
        if (this.currUser.UserType == ("2") && !this.sysconfig.IsTotalCanBetting) {
            para.CanBetting = false;
            throw new Error('用户身份不能投注');
        }
        if (parseFloat(!this.para.order.multiple ? "0" : this.para.order.multiple) < this.sysconfig.MinMultiple) {
            throw new Error('最小倍数不能小于' + this.sysconfig.MinMultiple);
        }
        // if (checklist.length > 0) {
        //     if (checkedlength < algorithm.BetNumLength && algorithm.BetNumLength <= 5) {
        //         throw new Error('必须选择' + algorithm.BetNumLength + '个位数');
        //     }
        // }
        if (this.para.order.bettingCount == 0) {
            if (this.para.playDetail.Algorithm.AlgorithmType.PickMode == '01') {
                throw new Error('请选择号码！');
            }
            if (this.para.playDetail.Algorithm.AlgorithmType.PickMode == '02') {
                throw new Error('请输入号码！');

            }
        }

        var b = {
            BettingCount: this.para.order.bettingCount,
            BettingMoney: this.chaseParams.totalMoney.toFixed(4),
            BettingNumber: this.para.order.selectNum,
            BuyIssueCount: this.chaseParams.totalCount,
            GraduationCount: this.para.adjustReward,
            IsChaseNo: true,
            IsStopAfterWinning: this.chaseParams.isStop ? true : false,
            IssueNo: this.para.currIssue.CurrentIssueNo,
            LotteryCode: this.para.lotteryCode,
            LotteryPlayDetailCode: this.para.playDetail.LotteryPlayDetailCode,
            Multiple: this.para.order.multiple,
            SelectMedian: this.para.order.SelectMedian,
            BettingInfoIssueList: []
        };
        var bettingmoney = 0;
        if (b.IsChaseNo) {
            // b.IsStopAfterWinning = this.chaseParams.isStopAfterWinning;
            var issuelen = this.chaseParams.issues.length;
            for (var i = 0; i < issuelen; i++) {
                var tmp = this.chaseParams.issues[i];
                if (tmp.checked) {
                    if (tmp.Multiple < this.sysconfig.MinMultiple) {
                        throw new Error('最小倍数不能小于' + this.sysconfig.MinMultiple);
                    }
                    var bettingmodel = {
                        IssueNo: tmp.IssueNo,
                        Multiple: tmp.Multiple,
                        PerPrice: this.sysconfig.PerBettingPrice * this.para.order.yuanjiaofen
                    };
                    b.BettingInfoIssueList.push(bettingmodel);

                    bettingmoney += b.BettingCount * bettingmodel.Multiple * bettingmodel.PerPrice;
                }
            }
        } else {
            var bettingmodel2 = {
                IssueNo: b.IssueNo,
                Multiple: b.Multiple,
                PerPrice: this.sysconfig.PerBettingPrice * this.para.order.yuanjiaofen
            };
            b.BettingInfoIssueList.push(bettingmodel2);
            bettingmoney = b.BettingCount * bettingmodel2.Multiple * bettingmodel2.PerPrice;
        }

        // b.BettingMoney = bettingmoney.toFixed(4);
        b.BuyIssueCount = b.BettingInfoIssueList.length;

        // this.bettingService.betting(b).then(s => {
        //     if (!s.Result) {
        //         errors.push(s);
        //     }
        // });
        ajaxList.push(this.bettingService.betting(b));
        ajaxList.forEach(r => {
            r.then(s => {
                if (!s.Result) {
                    errors.push(s);
                }
            });
        });

        Promise.all(ajaxList).then(() => {
            if (errors.length > 0) {
                var errorhtml = [];
                errors.forEach(e => {
                    errorhtml.push(e.Error);
                });
                this.alert.showAlert(errorhtml.join(''));
            } else {
                this.alert.showAlert("投注成功");
                var s = this.navCtrl.getViews();
                s.forEach(v => {
                    if (v.component == BettingOrderPage) {
                        this.viewCtrl.data = { "isBetting": true };
                        this.navCtrl.popTo(v, { "lotteryCode": this.para.lotteryCode } as any);
                        return false;
                    }
                });
            }
        });

    }


    //关闭
    //TQQ 2017-01-11
    dismiss(data?: any) {
        clearInterval(this.setIntervalid);
        this.viewCtrl.dismiss(data);
    }


    //开奖倒计时
    issueTimerCallback(time) {
        if (time > 0) {
            let t = PageDefault.formatTime(time / 1000);
            this.para.formatRemain = t.join(':');
        } else {
            clearInterval(this.setIntervalid);
            this.alert.showAlert("您好，" + this.para.currIssue.CurrentIssueNo + "期已截止，投注时请确认您选择的期号。");
            this.getIssue();
        }
    }

    //获取当前期号，当前期号结束剩余时间
    //TQQ 2017-01-11
    getIssue() {
        this.bettingService.getIssue(this.para.lotteryCode).then(s => {
            this.para.currIssue = s;
            this.setIntervalid = setInterval(s => {
                this.para.currIssue.RemainTime -= 1000;
                this.issueTimerCallback(this.para.currIssue.RemainTime);
            }, 1000);
        });
    }

    calculate(start) {
        var i = start ? start : 0;
        var issues = this.chaseParams.issues;
        for (; i < issues.length; i++) {
            var issue = issues[i];
            issue.BettingMoney = issue.checked ? this.sysconfig.PerBettingPrice * this.para.order.yuanjiaofen * this.InvestSumNum() * issue.Multiple : 0;
            issue.Reward = this.getChaseReward() * issue.Multiple;
            issue.BettingSumMoney = i < 1 ? issue.BettingMoney : issues[i - 1].BettingSumMoney + issue.BettingMoney;
            issue.Profit = issue.Reward - issue.BettingSumMoney;
            issue.Profitability = issue.BettingSumMoney == 0 ? '0' : ((issue.Reward - issue.BettingSumMoney) * 100 / issue.BettingSumMoney).toFixed(2);
        }
        // issues = $filter('filter')(this.chaseParams.issues, { 'checked': true });
        let betResults = new List(this.chaseParams.issues);
        issues = betResults.Where(s => s.checked).ToArray();
        this.chaseParams.totalCount = issues.length;
        this.chaseParams.totalMoney = issues.length <= 0 ? 0 : issues[issues.length - 1].BettingSumMoney;
    }

    // 信用玩法生成追号计划
    dollarGenerate() {
        this.chaseParams.totalCount = 0;
        this.chaseParams.totalMoney = 0;
        var issues = this.bettinghelper.getNextIssueNoList(
            this.para.currIssue.Issue,
            this.para.currIssue.CurrentIssueNo,
            this.chaseParams.count
        );
        this.chaseParams.issues = [];
        for (var j in issues) {
            var i = parseInt(j);
            var chasemodel = {
                SerialNo: i + 1,
                IssueNo: issues[i],
                Multiple: i > 0 ? this.chaseParams.issues[i - 1].Multiple : this.chaseParams.startMultiple,
                BettingMoney: 0,
                BettingSumMoney: 0,
                checked: true,
                PerPrice: 1
            };
            chasemodel.Multiple = parseFloat(chasemodel.Multiple);
            chasemodel.BettingMoney = this.bettingMoneyInit * chasemodel.Multiple;
            chasemodel.BettingSumMoney = this.chaseParams.issues.length == 0
                ? chasemodel.BettingMoney
                : this.chaseParams.issues[i - 1].BettingSumMoney + chasemodel.BettingMoney;
            this.chaseParams.issues.push(chasemodel);
            this.chaseParams.totalCount++;
            this.chaseParams.totalMoney = chasemodel.BettingSumMoney;
        }
    }

    // 信用玩法调整倍数后重新计算
    dollarCalculate(start?) {
        var issues = this.chaseParams.issues;
        for (var i = 0; i < issues.length; i++) {
            var issue = issues[i];
            issue.Multiple = parseFloat(issue.Multiple) || 0;
            issue.BettingMoney = issue.checked ? this.bettingMoneyInit * issue.Multiple : 0;
            issue.BettingSumMoney = i < 1
                ? issue.BettingMoney
                : issues[i - 1].BettingSumMoney + issue.BettingMoney;
        }
        let selected = new List(issues).Where(s => s.checked).ToArray();
        this.chaseParams.totalCount = selected.length;
        this.chaseParams.totalMoney = selected.length <= 0
            ? 0
            : selected[selected.length - 1].BettingSumMoney;
    }

    getDollarsIssueString() {
        let issueString = "";
        this.para.bettingMoneyCount.BettingInfoIssueList.forEach((issue, index) => {
            issueString += issue.IssueNo + "@";
            issueString += issue.Multiple + "@";
            issueString += issue.PerPrice + "@";
            issueString += issue.BettingMoney + "|";
        });
        this.para.bettingMoneyCount.BettingInfoIssueString =
            issueString.substr(0, issueString.length - 1);
    }

    // 信用玩法追号提交
    dollarSubmit() {
        this.para.bettingMoneyCount.BettingInfoIssueList = [];
        this.chaseParams.issues.forEach(issue => {
            if (issue.checked) {
                this.para.bettingMoneyCount.BettingInfoIssueList.push(issue);
            }
        });
        if (this.para.bettingMoneyCount.BettingInfoIssueList.length == 0) {
            this.alert.showAlert("您没有勾选任何追号计划!");
            return;
        }
        this.getDollarsIssueString();
        this.para.bettingMoneyCount.BettingMoney = this.chaseParams.totalMoney;
        this.para.bettingMoneyCount.IsChaseNo = 1;
        this.para.bettingMoneyCount.IsStopAfterWinning = this.chaseParams.isStop ? 1 : 0;

        let bettingInfo = this.para.bettingMoneyCount;
        bettingInfo.BettingInfoIssueList = [];
        bettingInfo.BettingItemList = [];
        let load = this.loadding.showLoding("投注中...");
        this.bettingService.dollarBetting(bettingInfo).then(result => {
            this.loadding.closeLoading(load);
            if (!result.Result) {
                this.alert.showAlert(result.Error || "追号失败");
                return;
            }
            this.alert.showAlert("追号成功");
            this.viewCtrl.dismiss({ isBetting: true });
        }).catch(() => {
            this.loadding.closeLoading(load);
            this.alert.showAlert("追号失败，请稍后重试");
        });
    }


}



// WEBPACK FOOTER //
// ./src/pages/bettingorder/bettingchase.ts